// import React, { useEffect, useRef, useState } from "react";

// const Hrmsabout = () => {
//   const imageRef = useRef(null);
//   const textRef = useRef(null);
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setIsVisible(true);
//           }
//         });
//       },
//       { threshold: 0.2 }
//     );

//     if (imageRef.current) observer.observe(imageRef.current);
//     if (textRef.current) observer.observe(textRef.current);

//     return () => {
//       if (imageRef.current) observer.unobserve(imageRef.current);
//       if (textRef.current) observer.unobserve(textRef.current);
//     };
//   }, []);

//   return (
//     <div className="industrial-container">
//       <style>
//         {`
//           .industrial-container {
//             display: flex;
//             flex-direction: row;
//             justify-content: space-between;
//             align-items: center;
//             padding: 40px 5%;
//             background-color: white;
//             flex-wrap: wrap;
//           }
//           .industrial-text {
//             width: 50%;
//             padding-left: 40px;
//             text-align: left;
//           }
//           .industrial-title {
//             font-size: 32px;
//             font-weight: bold;
//             margin-bottom: 20px;
//             color: black;
//             letter-spacing:0px;
//           }
//           .industrial-desc {
//             font-size: 16px;
//             line-height: 1.6;
//             margin-bottom: 15px;
//             text-align: justify;
//             color: black;
//           }
//           .industrial-image-section {
//             width: 45%;
//             text-align: center;
//           }
//           .industrial-image {
//             width: 80%;
//             max-width: 700px;
//             height: auto;
//             border-radius: 8px;
//           }

//           /* Animation styles */
//           .slide-in-left {
//             opacity: 0;
//             transform: translateX(-50px);
//             transition: all 1s ease-in-out;
//           }
//           .slide-in-right {
//             opacity: 0;
//             transform: translateX(50px);
//             transition: all 1s ease-in-out;
//           }
//           .visible {
//             opacity: 1;
//             transform: translateX(0);
//           }

//           /* Responsive */
//           @media (max-width: 1024px) {
//             .industrial-title {
//               font-size: 28px;
//             }
//             .industrial-desc {
//               font-size: 15px;
//             }
//           }
//           @media (max-width: 768px) {
//             .industrial-container {
//               flex-direction: column;
//               padding: 20px;
//             }
//             .industrial-text {
//               width: 100%;
//               padding-left: 0;
//               order: 2;
//             }
//             .industrial-image-section {
//               width: 100%;
//               order: 1;
//               margin-bottom: 30px;
//             }
//             .industrial-title {
//               font-size: 26px;
//               text-align: center;
//             }
//             .industrial-desc {
//               font-size: 14px;
//               text-align: left;
//             }
//           }
//           @media (max-width: 480px) {
//             .industrial-title {
//               font-size: 22px;
//             }
//             .industrial-desc {
//               font-size: 13px;
//             }
//           }
//         `}
//       </style>

//       {/* Image Section */}
//       <div
//         ref={imageRef}
//         className={`industrial-image-section slide-in-left ${
//           isVisible ? "visible" : ""
//         }`}
//       >
//         <img
//           src="/image/human-resource-bg-left-min.png"
//           alt="Industrial Automation"
//           className="industrial-image"
//         />
//       </div>

//       {/* Text Section */}
//       <div
//         ref={textRef}
//         className={`industrial-text slide-in-right ${
//           isVisible ? "visible" : ""
//         }`}
//       >
//         <h2 className="industrial-title">
//           Smarter HR Solutions for a Smarter Workforce
//         </h2>
//         <p className="industrial-desc">
//           For organizations managing large and diverse teams, our Human Resource
//           Management System (HRMS) ensures accuracy, efficiency, and compliance
//           in every HR process — from recruitment to retirement. Workflows and
//           modules are fully customizable to meet your unique organizational and
//           regulatory needs.
//         </p>
//         <p className="industrial-desc">
//           The platform seamlessly integrates with major payroll systems,
//           attendance tracking solutions, and performance management tools. As a
//           result, it becomes a core part of your organization’s human capital
//           management ecosystem.
//         </p>
//         <p className="industrial-desc">
//           Our HRMS comes with built-in employee profiles, automated leave and
//           payroll processing, and real-time analytics — ready to optimize your
//           HR operations from day one!
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Hrmsabout;



import React, { useEffect, useRef, useState } from "react";

const Hrmsabout = () => {
  const imageRef = useRef(null);
  const textRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (imageRef.current) observer.observe(imageRef.current);
    if (textRef.current) observer.observe(textRef.current);

    return () => {
      if (imageRef.current) observer.unobserve(imageRef.current);
      if (textRef.current) observer.unobserve(textRef.current);
    };
  }, []);

  return (
    <div className="hrms-about-wrapper">
      <div className="industrial-container">
        <style>
          {`
            .hrms-about-wrapper {
              display: flex;
              justify-content: center;
              background-color: white;
              width: 100%;
            }
            
            .industrial-container {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              padding: 40px 20px;
              background-color: white;
              flex-wrap: wrap;
              max-width: 1200px;
              width: 100%;
            }
            
            .industrial-text {
              width: 48%;
              padding-left: 20px;
              text-align: left;
            }
            
            .industrial-title {
              font-size: 32px;
              font-weight: bold;
              margin-bottom: 20px;
              color: black;
              letter-spacing: 0px;
            }
            
            .industrial-desc {
              font-size: 16px;
              line-height: 1.6;
              margin-bottom: 15px;
              text-align: justify;
              color: black;
            }
            
            .industrial-image-section {
              width: 48%;
              text-align: center;
            }
            
            .industrial-image {
              width: 100%;
              max-width: 500px;
              height: auto;
              border-radius: 8px;
            }

            /* Animation styles */
            .slide-in-left {
              opacity: 0;
              transform: translateX(-50px);
              transition: all 1s ease-in-out;
            }
            
            .slide-in-right {
              opacity: 0;
              transform: translateX(50px);
              transition: all 1s ease-in-out;
            }
            
            .visible {
              opacity: 1;
              transform: translateX(0);
            }

            /* Responsive */
            @media (max-width: 1024px) {
              .industrial-title {
                font-size: 28px;
              }
              
              .industrial-desc {
                font-size: 15px;
              }
            }
            
            @media (max-width: 900px) {
              .industrial-container {
                padding: 30px 15px;
              }
              
              .industrial-text {
                width: 100%;
                padding-left: 0;
                order: 2;
              }
              
              .industrial-image-section {
                width: 100%;
                order: 1;
                margin-bottom: 30px;
              }
              
              .industrial-title {
                font-size: 26px;
                text-align: center;
              }
              
              .industrial-desc {
                font-size: 14px;
                text-align: left;
              }
            }
            
            @media (max-width: 480px) {
              .industrial-container {
                padding: 20px 10px;
              }
              
              .industrial-title {
                font-size: 22px;
              }
              
              .industrial-desc {
                font-size: 13px;
              }
            }
          `}
        </style>

        {/* Image Section */}
        <div
          ref={imageRef}
          className={`industrial-image-section slide-in-left ${
            isVisible ? "visible" : ""
          }`}
        >
          <img
            src="/image/human-resource-bg-left-min.png"
            alt="HR Management System"
            className="industrial-image"
          />
        </div>

        {/* Text Section */}
        <div
          ref={textRef}
          className={`industrial-text slide-in-right ${
            isVisible ? "visible" : ""
          }`}
        >
          <h2 className="industrial-title">
            Smarter HR Solutions for a Smarter Workforce
          </h2>
          <p className="industrial-desc">
            For organizations managing large and diverse teams, our Human Resource
            Management System (HRMS) ensures accuracy, efficiency, and compliance
            in every HR process — from recruitment to retirement. Workflows and
            modules are fully customizable to meet your unique organizational and
            regulatory needs.
          </p>
          <p className="industrial-desc">
            The platform seamlessly integrates with major payroll systems,
            attendance tracking solutions, and performance management tools. As a
            result, it becomes a core part of your organization's human capital
            management ecosystem.
          </p>
          <p className="industrial-desc">
            Our HRMS comes with built-in employee profiles, automated leave and
            payroll processing, and real-time analytics — ready to optimize your
            HR operations from day one!
          </p>
        </div>
      </div>
    </div>
  );
};

export default Hrmsabout;